/**
 * @功能名称: 卡贷H5 v2.0 vue 扩展
 * @文件名称: cardloan.js
 * @Date: 2018/8/2 下午4:20.
 * @Author: liux
 * @Copyright（C）: 2014-2018 X-Financial Inc.   All rights reserved.
 */

import {
  post,
  postSlient,
  get,
  getSlient,
} from '../network/http'
import openH5Page from '../xyJsBridge/openH5Page'
import ua from '../helper/getBrowserInfo'
import addUrlQuery from '../helper/addUrlQuery'
import openJsBridge from '../jsBridge/openJsBridge'
import appInfo from '../helper/getAppInfo'
import {realType} from '../helper/utils'
import replaceDomain from '../xyHelper/replaceDomain'

var appinfo = appInfo()
var _ua = ua()

function getUrl({name, path, query}) {
  var hash = path || `/${name}`;
  var url = `${location.href.split('#')[0]}#${hash}`;
  if (realType(query) === 'object') {
    query = encodeURIComponent(JSON.stringify(query));
    url = `${location.href.split('#')[0]}#${hash}?query=${query}`;
  }
  return url;
}

export default function install (Vue, options) {
  Vue.prototype.alert = function () {
    return this.$root.$children[0].$refs.alert.show(...arguments)
  }
  Vue.prototype.confirm = function () {
    return this.$root.$children[0].$refs.confirm.show(...arguments)
  }
  Vue.prototype.toast = function () {
    return this.$root.$children[0].$refs.toast.show(...arguments)
  }
  Vue.prototype.report = function () {
    if(this.$root.hasOwnProperty('report') && typeof this.$root.report === 'function'){
      return this.$root.report(...arguments)
    }
  }
  Vue.prototype.reportInit = function () {
    if (this.$root.hasOwnProperty('reportInit') && typeof this.$root.reportInit === 'function') {
      return this.$root.reportInit(...arguments)
    }
  }
  Vue.prototype.xreport = function(){
    if (this.$root.hasOwnProperty('xreport') && typeof this.$root.xreport === 'function') {
      return this.$root.xreport(...arguments)
    }
  }
  Vue.prototype.commit = function () {
    return this.$store.commit(...arguments)
  }
  Vue.prototype.dispatch = function () {
    return this.$store.dispatch(...arguments)
  }
  Vue.prototype.open = function (url, pageTitle='') {
    if (/^jsbridge:\/\//.test(url)) {
      return openJsBridge(url)
    }
    if (!/^http(s)?:\/\//.test(url)) {
      return false
    }
    pageTitle = encodeURIComponent(pageTitle)
    url = addUrlQuery(url,{pageTitle:pageTitle})
    var src = encodeURIComponent(url);
    if (_ua.isBjAPP) {
      openH5Page({'jumpUrl': url});
    } else if (_ua.isLiCai) {
      openJsBridge(`xiaoying://invest/Web/open?url=${src}`)
    } else {
      setTimeout(() => {
        location.href = replaceDomain(url)
      }, 50)
    }
  }
  Vue.prototype.push = function ({name, path, query}) {
    if (appinfo.app) {
      setTimeout(()=>{
        openH5Page({jumpUrl: getUrl(...arguments), data: this.$store.state})
      },0)
    } else {
      this.$router.push(...arguments)
    }
  }
  Vue.prototype.replace = function ({name, path, query}) {
    if (appinfo.app) {
      location.replace(replaceDomain(getUrl(...arguments)))
    } else {
      this.$router.replace(...arguments)
    }
  }
  Vue.prototype.post = post
  Vue.prototype.postSlient = postSlient
  Vue.prototype.get = get
  Vue.prototype.getSlient = getSlient

}
